/**

Brave People Fade in on Scroll

Author: Bryce Walter, bryce@bravepeople.co, brycejwalter@gmail.com
Owner: Brave People

Step 1: Include //ajax.googleapis.com/ajax/libs/jquery/1.9.1/jquery.min.js and //ajax.googleapis.com/ajax/libs/jqueryui/1.10.3/jquery-ui.min.js
Step 2: Add class ".fade-element" to items that you would like to recieve an ".active" class on scroll
Step 3: Add the amount that you would like the fade to offset for that element by added an attribute "fade-offset". ex: fade-offset="100"
Step 4: Set up the styles that you would like to occur once the active class is added to the section

**/


// Fade in on scroll function

function fadeInOnScroll() {
  $(".fade-element").each(function () {

    if (Math.round($(window).scrollTop()) + Math.round($(window).height()) >= Math.round($(this).offset().top)) {
      $(this).addClass("active");
    } else {
      $(this).removeClass("active");
    }

  });
}


// Throttle Scroll for better Performance

var fadescrollTimeout;
var fadethrottle = 100;

$(window).on('scroll', function () {
  if (!fadescrollTimeout) {
    fadescrollTimeout = setTimeout(function () {

      fadeInOnScroll();
      fadescrollTimeout = null;

    }, fadethrottle);
  }
});

window.addEventListener('resize', function () {
  fadeInOnScroll();
});

$(document).ready(function () {
  fadeInOnScroll();
});